import { render } from "./RevenueChart.vue?vue&type=template&id=3b5ef4f7&ts=true"
import script from "./RevenueChart.vue?vue&type=script&lang=ts"
export * from "./RevenueChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__